import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { FiInfo } from "react-icons/fi";

/*
Small info affordance pinned to a card's top-right corner. The card must have
`position: relative` (tn-card and tn-attention-card both do).

Clicks stop here: the dashboard cards are themselves clickable filters, and
tapping the info icon shouldn't apply one.
*/
const stop = function (e) {
  e.stopPropagation();
};

const InfoTooltip = function (props) {
  const { text, placement } = props;
  if (!text) return null;

  return (
    <Tooltip title={text} placement={placement || "top"} arrow>
      <span
        className="tn-info-tooltip"
        tabIndex={0}
        aria-label={text}
        onClick={stop}
      >
        <FiInfo size={14} strokeWidth={2} />
      </span>
    </Tooltip>
  );
};

export default InfoTooltip;
